import { render, staticRenderFns } from "./AlarmSettings.vue?vue&type=template&id=3d3accc2&"
import script from "./AlarmSettings.vue?vue&type=script&lang=js&"
export * from "./AlarmSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports